/* Shared storefront / Grid Editor row layout. Only presentation changes; DOM order stays native. */
(()=>{
 const instances=new WeakMap();
 window.AplovioGridLayout={attach(owner,{preserveScroll=false}={}){
  if(instances.has(owner))return instances.get(owner);
  const grid=owner.querySelector('[data-collection-grid]');if(!grid)return;
  const abort=new AbortController();let frame=0,lastKey='';
  const layout=()=>{
   if(!owner.isConnected)return;
   const nodes=[...grid.children].filter(node=>node.matches('[data-grid-product],[data-grid-editorial]'));
   if(owner.dataset.selected!=='true'){
    delete owner.dataset.balanced;nodes.forEach(node=>{node.style.removeProperty('--ap-balanced-width');node.removeAttribute('data-balanced-single');});lastKey='';return;
   }
   const mobile=matchMedia('(max-width:989px)').matches,style=getComputedStyle(owner);
   let columns=mobile?Number(style.getPropertyValue('--ap-grid-mobile-columns')):owner.dataset.layout==='editorial'?2:Number(style.getPropertyValue('--ap-grid-columns'));
   columns=Math.max(1,Math.min(6,columns||4));
   if(owner.dataset.layout==='classic'&&owner.dataset.density==='dense')columns=mobile?3:Math.min(6,columns+1);
   const key=[mobile,columns,...nodes.map(node=>(node.dataset.gridProduct||node.dataset.gridEditorial)+':'+(node.dataset.appearance||node.dataset.width))].join('|');
   if(key===lastKey)return;lastKey=key;
   const visible=preserveScroll?nodes.filter(node=>{const box=node.getBoundingClientRect();return box.top<innerHeight&&box.bottom>0;}):[];
   const anchor=visible.find(node=>node.getBoundingClientRect().top>=0)||visible[0];
   const before=anchor?.getBoundingClientRect().top;
   owner.dataset.balanced='true';
   let run=[];
   const width=count=>`calc((100% - ${count-1} * var(--ap-balanced-gap)) / ${count})`;
   const flush=()=>{
    if(!run.length)return;
    const rows=Math.ceil(run.length/columns),small=Math.floor(run.length/rows),larger=run.length%rows;
    let offset=0;
    for(let row=0;row<rows;row++){
     const count=small+(row<larger?1:0);
     for(const node of run.slice(offset,offset+count)){
      node.style.setProperty('--ap-balanced-width',count===1&&!mobile?width(2):width(count));
      node.toggleAttribute('data-balanced-single',count===1&&!mobile);
     }
     offset+=count;
    }
    run=[];
   };
   for(const node of nodes){
    const full=node.dataset.appearance==='large'||node.dataset.appearance==='gallery'||node.dataset.width==='full';
    if(full){flush();node.style.setProperty('--ap-balanced-width','100%');node.removeAttribute('data-balanced-single');}
    else run.push(node);
   }
   flush();
   if(anchor&&Number.isFinite(before)){const delta=anchor.getBoundingClientRect().top-before;if(Math.abs(delta)>1)window.scrollBy({top:delta,behavior:'instant'});}
  };
  const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(layout);};
  const resize=new ResizeObserver(schedule);resize.observe(owner);
  const mutation=new MutationObserver(schedule);mutation.observe(grid,{childList:true});
  const settings=new MutationObserver(schedule);settings.observe(owner,{attributes:true,attributeFilter:['data-density','data-layout','data-selected','style']});
  window.addEventListener('resize',schedule,{signal:abort.signal});
  const instance={layout,destroy(){abort.abort();resize.disconnect();mutation.disconnect();settings.disconnect();cancelAnimationFrame(frame);instances.delete(owner);}};
  instances.set(owner,instance);layout();return instance;
 }};
})();
